import { useQuery } from 'react-query';
import isNil from 'lodash/isNil.js';
import { useFirebase } from 'components/Firebase/index.js';
import useOrgId from 'hooks/useOrgId.js';
import { productCatalogueServerUrl } from '../../../client-config.js';

const DEFAULT_QUERY_PARAMS = {
  active: true,
};

export default function useProductFeeds(options = {}) {
  const firebase = useFirebase();
  const orgId = useOrgId();
  const { queryParams = DEFAULT_QUERY_PARAMS, ...queryOptions } = options;

  return useQuery({
    queryKey: ['productFeeds', orgId, queryParams],
    queryFn: async () => {
      const validParams = Object.entries({
        ...DEFAULT_QUERY_PARAMS,
        ...queryParams,
      }).filter(([, value]) => !isNil(value));

      const idToken = await firebase.getIdToken();
      const fetchUrl = new URL(`${productCatalogueServerUrl}/api/v1/orgs/${orgId}/feeds`);
      const urlParams = new URLSearchParams(validParams);
      fetchUrl.search = urlParams.toString();

      const response = await fetch(fetchUrl.toString(), {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${idToken}`,
        },
      });

      const { ok, status } = response;
      if (ok) {
        return response.json();
      } else {
        throw new Error(`Failed to fetch feeds. Status: ${status}`);
      }
    },
    enabled: !!orgId,
    ...queryOptions,
  });
}
